import { FormControlLabel, Switch } from "@mui/material";
import { CognitoUser, CognitoUserPoolType, UserAccountsService } from "gen/clients";
import * as React from "react";
import { useMutation } from "react-query";
import { SnackbarApiError } from "components/SnackbarApiError/SnackbarApiError";

interface Props {
  userPool: CognitoUserPoolType;
  cognitoUser: CognitoUser;
  onSuccess: () => void;
  disabled?: boolean;
}

const CognitoStateSwitch: React.FC<Props> = ({ userPool, cognitoUser, onSuccess, disabled }) => {
  const {
    mutate,
    error: mutateError,
    isLoading: isMutateLoading
  } = useMutation({
    mutationFn: UserAccountsService.changeCognitoUserState,
    onSuccess
  });

  const onClick = React.useCallback(
    event => {
      mutate({
        userPool,
        cognitoUsername: encodeURIComponent(cognitoUser.username),
        requestBody: {
          enabled: event.target.checked
        }
      });
    },
    [mutate, userPool, cognitoUser]
  );

  return (
    <>
      {mutateError && <SnackbarApiError error={mutateError} />}
      <FormControlLabel
        control={
          <Switch
            checked={cognitoUser?.enabled || false}
            onChange={onClick}
            disabled={isMutateLoading || !cognitoUser || disabled}
            size="small"
          />
        }
        label={cognitoUser?.enabled ? "Yes" : "No"}
        labelPlacement="end"
        sx={{ ml: 1 }}
      />
    </>
  );
};

export { CognitoStateSwitch };
